import { ComboBox, renderSelectOptions } from "cy-ui/components/Combobox";
import { cn } from "cy-fe/src/utils/cn";
import { ChevronDown } from "lucide-react";

export interface SelectOption<T extends number | string> {
  id: T;
  name: string;
  prefix?: string;
}

export function SelectComboBox<T extends number | string>({
  options,
  onChange,
  selectedId,
  error,
  label,
  "data-testid": dataTestId,
}: {
  options: SelectOption<T>[];
  onChange: (id: T | null) => void;
  selectedId: T | null;
  error: boolean;
  label?: string;
  "data-testid"?: string;
}) {
  return (
    <ComboBox<SelectOption<T>>
      label={label}
      error={error}
      buttonChildren={(val) => (
        <>
          {val?.name}
          <ChevronDown className="absolute right-2" />
        </>
      )}
      buttonClassName={cn("flex-grow")}
      getOptions={(query) => {
        query = query.trim().toLowerCase();
        return options.filter(
          (x) =>
            !query ||
            `${x.prefix || ""} ${x.name}`.toLowerCase().includes(query),
        );
      }}
      maxHeight={16 * 30}
      onChange={(x) => {
        if (x == null) {
          onChange(null);
          return;
        }
        onChange(x.id);
      }}
      renderItems={(opts) =>
        renderSelectOptions(
          opts.map((x) => ({
            prefix: x.prefix,
            value: x,
            key: x.id,
            label: x.name,
          })),
        )
      }
      value={options.find((x) => x.id === selectedId) || null}
      data-testid={dataTestId}
    />
  );
}
